'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _CalendarTableCell = require('./CalendarTableCell');

var _CalendarTableCell2 = _interopRequireDefault(_CalendarTableCell);

var _dateUtils = require('../../utils/dateUtils');

var _OpeningCollection = require('../../models/OpeningCollection');

var _OpeningCollection2 = _interopRequireDefault(_OpeningCollection);

var _reactUtils = require('../../utils/reactUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CalendarTableRow = function (_React$Component) {
  _inherits(CalendarTableRow, _React$Component);

  function CalendarTableRow() {
    _classCallCheck(this, CalendarTableRow);

    return _possibleConstructorReturn(this, (CalendarTableRow.__proto__ || Object.getPrototypeOf(CalendarTableRow)).apply(this, arguments));
  }

  _createClass(CalendarTableRow, [{
    key: '_renderCells',
    value: function _renderCells() {
      var _props = this.props,
          openings = _props.openings,
          dates = _props.dates,
          startOfWeek = _props.startOfWeek,
          openingTarget = _props.openingTarget,
          onOpeningClick = _props.onOpeningClick,
          renderOpening = _props.renderOpening;

      var collection = new _OpeningCollection2.default(openings);
      return dates.map(function (date, index) {
        var isStartOfWeek = index !== 0 && date.day() === startOfWeek;
        var openingsByDate = collection.filterByDate(date);
        return _react2.default.createElement(_CalendarTableCell2.default, {
          key: date,
          openings: openingsByDate,
          openingTarget: openingTarget,
          showWeekDivider: isStartOfWeek,
          onOpeningClick: onOpeningClick,
          renderOpening: renderOpening
        });
      });
    }
  }, {
    key: '_renderLeftNavCell',
    value: function _renderLeftNavCell(startOfHour) {
      var _props2 = this.props,
          time = _props2.time,
          timeFormat = _props2.timeFormat,
          renderRowTime = _props2.renderRowTime;

      if (!startOfHour) {
        return _react2.default.createElement('td', null);
      }
      var rowTime = void 0;
      if (renderRowTime) {
        rowTime = renderRowTime({ time: time });
      } else {
        rowTime = time.format(timeFormat);
      }
      return _react2.default.createElement(
        'td',
        { className: 'calendar-table__time' },
        rowTime
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var time = this.props.time;

      var startOfHour = (0, _dateUtils.isStartOfHour)(time);
      var classes = (0, _classnames2.default)({ 'calendar-table__hour': startOfHour });
      return _react2.default.createElement(
        'tr',
        { className: classes },
        this._renderLeftNavCell(startOfHour),
        this._renderCells(),
        _react2.default.createElement('td', null)
      );
    }
  }]);

  return CalendarTableRow;
}(_react2.default.Component);

CalendarTableRow.displayName = 'CalendarTableRow';
CalendarTableRow.propTypes = {
  time: _reactUtils.momentShape.isRequired,
  timeFormat: _propTypes2.default.string,
  openings: _propTypes2.default.arrayOf(_reactUtils.openingShape).isRequired,
  dates: _propTypes2.default.arrayOf(_reactUtils.momentShape),
  startOfWeek: _propTypes2.default.number,
  openingTarget: _propTypes2.default.string,
  onOpeningClick: _propTypes2.default.func,
  renderRowTime: _propTypes2.default.func,
  renderOpening: _propTypes2.default.func
};
CalendarTableRow.defaultProps = {
  timeFormat: 'h',
  startOfWeek: 0
};
exports.default = CalendarTableRow;